import React, { useEffect, useState } from 'react';
import { TextField, MenuItem, Grid, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { obtenerPaises, obtenerDocumentos, obtenerDatosHotel } from '../../services/motorService';
import Cookies from 'js-cookie';


const PersonalData = ({ formValues, setFormValues, setIsFormValid }) => {
    const [emailTouched, setEmailTouched] = useState(false);
    const [phoneTouched, setPhoneTouched] = useState(false);
    const hotcod = Cookies.get('hotCod');
    const [datosHotel, setDatosHotel] = useState({});
    const [country, setCountries] = useState([]);
    const [documents, setDocuments] = useState([]);
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const validatePhone = (phone) => {
        const regex = /^[0-9]+$/;
        return regex.test(phone);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });

        if (name === 'correoElectronico') {
            setEmailTouched(true);
        } else if (name === 'reservatelefono') {
            setPhoneTouched(true);
        }
    };

    const handleDateChange = (date) => {
        if (date && date.isValid()) {
            // Convertir la fecha seleccionada en UTC, ignorando la zona horaria local
            const utcDate = dayjs(date).startOf('day').toDate();
            setFormValues({
                ...formValues,
                reservafechanacimiento: utcDate,
            });
        } else {
            setFormValues({
                ...formValues,
                reservafechanacimiento: null,
            });
        }
    };

    useEffect(() => {
        // Verificar si todos los campos obligatorios están completos y válidos
        const isValid =
            formValues.motorreservanombretitular.trim() &&
            formValues.motorreservaapellidotitular.trim() &&
            formValues.reservatipodocumento &&
            formValues.reservadocumento.trim() &&
            formValues.reservatelefono.trim() &&
            validatePhone(formValues.reservatelefono) &&
            formValues.correoElectronico.trim() &&
            validateEmail(formValues.correoElectronico) &&
            formValues.reservadireccion.trim() &&
            formValues.reservafechanacimiento &&
            formValues.reservapais;

        setIsFormValid(isValid);

        const getData = async () => {
            try {
                const data = await obtenerDatosHotel(hotcod);
                setDatosHotel(data);
                const hotCodAdmintour = data.MotorHotAdmintour;
                const paises = await obtenerPaises(data.MotorHotAdmintour);
                const coleccionpaises = paises.ColeccionPais;
                setCountries(coleccionpaises);
                const documentos = await obtenerDocumentos(data.MotorHotAdmintour);
                const coleccionDocumentos = documentos.ColeccionTipoDocumento;
                setDocuments(coleccionDocumentos);
            } catch (error) {
                console.error('Error fetching hotel data:', error);
            }
        };
        getData();

    }, [formValues, setIsFormValid]);



    return (
        <Grid container spacing={2} sx={{ paddingBottom: 4 }}>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="motorreservanombretitular"
                    required
                    fullWidth
                    label="Nombre"
                    value={formValues.motorreservanombretitular}
                    onChange={handleInputChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="motorreservaapellidotitular"
                    required
                    fullWidth
                    label="Apellido"
                    value={formValues.motorreservaapellidotitular}
                    onChange={handleInputChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="reservatipodocumento"
                    required
                    fullWidth
                    select
                    label="Tipo de documento"
                    value={formValues.reservatipodocumento}
                    onChange={handleInputChange}
                >
                    {documents.map((option) => (
                        <MenuItem key={option.TipoDocCodigo} value={option.TipoDocCodigo}>
                            {option.TipoDocDescripcion}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="reservadocumento"
                    required
                    fullWidth
                    label="N° documento"
                    value={formValues.reservadocumento}
                    onChange={handleInputChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="reservatelefono"
                    required
                    fullWidth
                    label="Teléfono"
                    value={formValues.reservatelefono}
                    onChange={handleInputChange}
                    error={phoneTouched && !validatePhone(formValues.reservatelefono)}
                    helperText={phoneTouched && !validatePhone(formValues.reservatelefono) ? "Teléfono inválido" : ""}
                    type="tel"  // Cambiar el tipo a tel
                    inputProps={{ pattern: "[0-9]*" }}  // Asegura que solo se pueden ingresar números
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="correoElectronico"
                    required
                    fullWidth
                    label="Correo electrónico"
                    value={formValues.correoElectronico}
                    onChange={handleInputChange}
                    error={emailTouched && !validateEmail(formValues.correoElectronico)}
                    helperText={emailTouched && !validateEmail(formValues.correoElectronico) ? "Correo electrónico inválido" : ""}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={formValues.reservafechanacimiento ? dayjs(formValues.reservafechanacimiento) : null}
                        onChange={handleDateChange}
                        label="Fecha de nacimiento"
                        format="DD/MM/YYYY"
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name="reservapais"
                    required
                    fullWidth
                    select
                    label="País"
                    value={formValues.reservapais}
                    onChange={handleInputChange}
                >
                    {country.map((option) => (
                        <MenuItem key={option.HotelPaisCodigo} value={option.HotelPaisCodigo}>
                            {option.HotelPaisNombre}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="reservadireccion"
                    required
                    fullWidth
                    label="Dirección"
                    value={formValues.reservadireccion}
                    onChange={handleInputChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="reservaobservaciones"
                    fullWidth
                    label="Observaciones"
                    multiline
                    rows={2}
                    value={formValues.reservaobservaciones}
                    onChange={handleInputChange}
                />
            </Grid>
            <Grid item xs={12} >
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>¿Tiene vehículo?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="reservaautocolor"
                                    fullWidth
                                    label="Color del vehículo"
                                    value={formValues.reservaautocolor}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="reservaautomarca"
                                    fullWidth
                                    label="Marca del vehículo"
                                    value={formValues.reservaautomarca}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="reservaautomatricula"
                                    fullWidth
                                    label="Matrícula del vehículo"
                                    value={formValues.reservaautomatricula}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </Grid>
    );
};

export default PersonalData;
